module.exports = __webpack_public_path__ + "static/media/003-tanzania.af196556.svg";